import { IS_PROD } from 'modules/common/constants/env';

import { ETH_SEPOLIA_RPC_URL, ETH_RPC_URL } from '../constants';

export const getWeb3EthRpcUrl = () =>
  IS_PROD ? ETH_RPC_URL : ETH_SEPOLIA_RPC_URL;
